var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.989,
    height: 13.763,
    viewBox: "0 0 14.989 13.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,5.453v9.81L5.792,12.81,10.7,15.263l4.292-2.453V3L10.7,5.453,5.792,3Z",
    fill: "none",
    stroke: "#fd6c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3v9.81",
    transform: "translate(-6.208)",
    fill: "none",
    stroke: "#fd6c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,9v9.81",
    transform: "translate(-13.303 -3.547)",
    fill: "none",
    stroke: "#fd6c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOrange);
export default __webpack_public_path__ + "static/media/map_orange.cc9fb29804dc29ee95364ff9e964923a.svg";
export { ForwardRef as ReactComponent };